// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1eANz","name":"styles_name__ZOHWN","phone":"styles_phone__25LUR"};